<template>
  <router-view />
</template>

<script>
export default {
  name: "clothmanagement",
};
</script>